import React from 'react'
import T from 'prop-types'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'

import IconButton from 'components/atoms/IconButton'

export default function ConfirmationDialog({
  dataTestId,
  title,
  content,
  contentComponent,
  contentProps,
  confirmLabel,
  open,
  hideCancel,
  handleClose = () => {},
  handleSubmit = () => {},
  readOnly,
}) {
  const { t } = useTranslation()

  const Content = contentComponent || Typography

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        {title}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          variant="outlined"
          sx={{
            position: 'absolute',
            right: (theme) => theme.spacing(0.5),
            top: (theme) => theme.spacing(0.5),
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Content
          variant={contentComponent ? undefined : 'body2'}
          {...contentProps}
        >
          {content}
        </Content>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        {!hideCancel ? (
          <Button variant="contained" onClick={handleClose} color="secondary">
            {t('common.form.cancel')}
          </Button>
        ) : (
          <div />
        )}
        <Button
          disabled={readOnly}
          variant="contained"
          onClick={handleSubmit}
          color="primary"
          data-testid="button-dialog-confirm"
        >
          {confirmLabel || t('common.form.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ConfirmationDialog.propTypes = {
  title: T.string,
  content: T.node,
  contentComponent: T.oneOfType([T.object, T.string]),
  contentProps: T.object,
  confirmLabel: T.string,
  open: T.bool,
  hideCancel: T.bool,
  handleClose: T.func,
  handleSubmit: T.func,
  readOnly: T.bool,
}
